// Horizontal Linear Stapper
import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Or AdapterMoment, AdapterDayjs, etc.




// rct card box
import { RctCardContent } from 'Components/RctCard';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
   allAcademys,
   allAdminMembers,
   allAcademyAdminList,
   addAcademyAdmin,
   assignAcademyAdmin
} from 'Actions';

function getSteps() {
   return ['Select Academy', 'Create or Assign Admin'];
}


class AcademyAdminWorkflow extends React.Component {
   static propTypes = {
      classes: PropTypes.object,
   };

   UNSAFE_componentWillMount() {
		this.props.allAcademys();
      this.props.allAdminMembers();      
	}

  

   state = {
      activeStep: 0,
      skipped: new Set(),
      academy:"",
      seladmin:"",
      selectedDate: moment(),
      lstaction:0,
   };
   isStepOptional = step => {
      return step === 1;
   };
   isStepSkipped(step) {
      return this.state.skipped.has(step);
   }
   handleNext = () => {
      const { activeStep } = this.state;
      let { skipped } = this.state;
      let { academy } = this.state;
      let { lstaction } = this.state;
      let { seladmin } = this.state;
      if(activeStep==0 && academy==""){
           alert('Please select the academy');     
      }else if(activeStep==1){
          if(lstaction==0 && seladmin==""){
            alert('Please select the admin or create admin');   
          }else{
            this.props.assignAcademyAdmin(academy,seladmin,1).then((data) => {         
               if(data.status==1){
                  this.setState({
                     activeStep: 2,
                  });
                  
               }
            });

           
          }       
      }else{
        
         if(this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
         }
         this.setState({
            activeStep: activeStep + 1,
            skipped,
         });
      }
   };

   selAcademy = (evt) =>{
      const academyid=evt.target.value;
      this.setState({academy: academyid});
      this.props.allAcademyAdminList(academyid);
   }
   handleBack = () => {
      const { activeStep } = this.state;
      this.setState({
         activeStep: activeStep - 1,
      });
   };
  

   handleDateChange = (date) => {
		this.setState({ selectedDate: date });
	};

   addHandleSubmit(event){
      event.preventDefault();
      
      this.props.addAcademyAdmin(event,this.state.academy,this.state.selectedDate,2).then((data) => {         
         if(data.status==1){
            this.setState({
               lstaction:1,
               activeStep: 2,
            });
            document.getElementById("membersform").reset(); 
         }
      });
      
   }

   render() {
      const steps = getSteps();
      const { activeStep } = this.state;
      const { academylists, adminlists, academyadminlists, loading } = this.props;
      return (
         <div className="hoz-linear-stepper">
            <Stepper alternativeLabel nonLinear activeStep={activeStep}>
               {steps.map((label, index) => {
                  const props = {};
                  const labelProps = {};
                  if (this.isStepOptional(index)) {
                     labelProps.optional = '';
                  }
                  if (this.isStepSkipped(index)) {
                     props.completed = false;
                  }
                  return (
                     <Step key={label} {...props}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                     </Step>
                  );
               })}
            </Stepper>
            <div className="pl-40">
                 
                  {(function(){
                  if (activeStep === 0) {

                  //{activeStep === 0 ? (
                     return <div>

                         <div className="row">
                           <div className="col-md-12">
                             <div className="form-group col-md-6">
                             <FormControl fullWidth>
                                 <InputLabel htmlFor="age-simple">Academy</InputLabel>
                                 <Select value={this.state.academy}  onChange={this.selAcademy}
                                    inputProps={{ name: 'academy', }}>
                                    <MenuItem value=""><em>None</em></MenuItem>                                    
                                    {academylists.map((acdylst) => (
                                         <MenuItem value={acdylst.aadID}>{acdylst.aad_name}</MenuItem>
                                    ))}
                                 </Select>
                                 </FormControl>
                              </div>
                           </div>
                           
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back
                              </Button>
                              <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                                 {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                              </Button>
                           
                        </div>   
                     </div>  
                   } else if (activeStep === 1) {    
                  //) : (
                     return <div>
                        <div className="row">
                           <div className="col-md-6">
                              <RctCollapsibleCard colClasses="col-sm-12 col-md-12 col-lg-12 w-xs-full" heading="Academy Admin">
                                 <RctCardContent>
                                    <div className="upcoming-events-wrap">
                                       <List className="list-unstyled p-0">
                                          {academyadminlists.map((acdylst) => (
                                             <ListItem className="border-bottom px-0 d-flex justify-content-between align-content-start">
                                                <div>
                                                   <h5>{acdylst.student}</h5>
                                                </div>
                                                <div>
                                                   
                                                </div>
                                             </ListItem>
                                          ))}
                                       </List>
                                    </div>
                                 </RctCardContent>
                              </RctCollapsibleCard>
                           </div>
                           <div className="col-md-6">
                              
                              <div className="col-md-12">
                                 <RctCollapsibleCard>
                                 <FormControl fullWidth>
                                    <InputLabel htmlFor="age-simple">Select Admin Members</InputLabel>
                                    <Select value={this.state.seladmin}  onChange={evt => this.setState({seladmin: evt.target.value})}
                                       inputProps={{ name: 'academyadmin', }}>
                                       <MenuItem value=""><em>None</em></MenuItem>                                    
                                       {adminlists.map((acdylst) => (
                                          <MenuItem value={acdylst.uudID}>{acdylst.student}</MenuItem>
                                       ))}
                                    </Select>
                                 </FormControl>
                                 </RctCollapsibleCard>
                              </div>
                              <div className="col-md-12 text-center"> (OR) </div>
                              <div className="col-md-12">
                                 <RctCollapsibleCard>
                                 <form autoComplete="off"  id="membersform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                    <h4>Add Academy Admin</h4>
                                    <div className="form-group">
                                       <TextField  required id="fname" name="fname" fullWidth label="First Name" />
                                    </div>
                                    <div className="form-group">
                                       <TextField required id="lname" name="lname" fullWidth label="Last Name" />
                                    </div>
                                    <div className="form-group">
                                       <TextField  type="email" required id="email" autoComplete="new-email" name="email" fullWidth label="Email"  />
                                    </div>
                                    <div className="form-group">
                                       <TextField  type="phone" required id="mobile" name="mobile" fullWidth label="Mobile" />
                                    </div>
                                    <div className="form-group">
                                       
                                       <Fragment>
                                          <div className="rct-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date of Birth"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            inputFormat="yyyy-MM-dd"
            components={{
              LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
              RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
            }}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
          />
        </LocalizationProvider>
      </div>
                                       </Fragment>
                                   
                                    </div>
                                    <FormControl fullWidth>
                                                <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                                <Select inputProps={{ name: 'gender', id: 'gender', }} required >
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   <MenuItem value="1"><em>Male</em></MenuItem>
                                                   <MenuItem value="2"><em>Female</em></MenuItem>                                   
                                                </Select>
                                    </FormControl> 
                                    <div className="form-group">
                                       <TextField type="password" required id="password" autoComplete="new-password" name="password" fullWidth label="Password" />
                                    </div>
                                    <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                    </div>
                                 </form>  
                                 </RctCollapsibleCard> 
                              </div>
                           </div>
                           <Button disabled={activeStep === 0} onClick={this.handleBack} className="btn-danger text-white mr-3 mb-3" >
                              Back
                           </Button>
                           <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                           </Button>
                        </div>   
                     </div>

                   }else{
                     return <div>
                           <div className="row">
                              <div className="col-md-12">
                                 <div className="alert bg-success text-white col-sm-12 col-md-6 col-lg-6" role="alert">
                                    <strong>Well done!</strong> You successfully assign academy admin.
                                 </div>
                              </div>
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back to Home
                              </Button>
                           </div>
                     </div>
                   }  
                  }).call(this)} 
                  
            </div>
         </div>
      );
   }
}




const mapStateToProps = ({ academy, mostlyused }) => {
	const { academylists, loading } = academy;
   const { adminlists, academyadminlists } = mostlyused;
	return { academylists, adminlists, academyadminlists, loading };
}

export default connect(mapStateToProps, {
   allAcademys,
   allAdminMembers,
   allAcademyAdminList,
   addAcademyAdmin,
   assignAcademyAdmin
})(AcademyAdminWorkflow); 
